const MapSection = () => {
  return (
    <section className="bg-white">
      <div className="h-[400px] w-full bg-neutral-200 relative">
        <div className="absolute inset-0 flex items-center justify-center">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.103725883462!2d72.82259551541428!3d19.062649857090618!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c91b6d6fe377%3A0x70c601fc8eda6a1b!2sMumbai%2C%20Maharashtra%2C%20India!5e0!3m2!1sen!2sus!4v1650000000000!5m2!1sen!2sus" 
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title="Varsha Seeds Location"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
